import React, { useState } from "react";
import Achievements from "./Achievements";
import AchievementsEn from "./English/AchievementsEn";
import PersonalInfo from "./PersonalInfo";
import PersonalInfoEn from "./English/PersonalInfoEn";
import Skills from "./Skills";
import SkillsEn from "./English/SkillsEn";
import Stuff from "./Stuff";
import StuffEn from "./English/StuffEn";
import { useLanguage } from "../../context/LanguageContext";


const Index = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <section className="main-content">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-5 col-12">
            <div className="row">
              <div className="col-12">
                <h3 className="text-uppercase custom-title mb-0 ft-wt-600">
                  {language === "hu" ? "Magunkról" : "About Us"}
                </h3>
              </div>

              <div className="col-12">
                {language === "hu" ? (
                  <PersonalInfo key="hu-personal" />
                ) : (
                  <PersonalInfoEn key="en-personal" />
                )}
              </div>
            </div>
          </div>

          <div className="col-xl-6 col-lg-7 col-12 mt-5 mt-lg-0">
            {language === "hu" ? (
              <Achievements key="hu-achievements" />
            ) : (
              <AchievementsEn key="en-achievements" />
            )}
          </div>
        </div>

        <hr className="separator" />

        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase pb-4 pb-sm-5 mb-3 mb-sm-0 text-left text-sm-center custom-title ft-wt-600">
              {language === "hu" ? "Miért válasszon minket?" : "Why Choose Us?"}
            </h3>
          </div>
          {language === "hu" ? <Skills key="hu-skills" /> : <SkillsEn key="en-skills" />}
        </div>

        <hr className="separator" />

        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase pb-5 mb-0 text-left text-sm-center custom-title ft-wt-600">
              {language === "hu" ? "Ismerje meg szakértőinket!" : "Meet Our Experts!"}
            </h3>
          </div>
          <div className="col-lg-12 m-15px-tb">
            {language === "hu" ? <Stuff key="hu-stuff" /> : <StuffEn key="en-stuff" />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;

